<ng-template #bamDialog data-sample="bamDialog">
  <mdw-dialog>This is where the BAM content goes</mdw-dialog>
  <!-- <div class="surface-floating border-radius-200 pad-200 bam-content">
    <mdw-dialog-header title="This is a BAM" [showCloseButton]="true"></mdw-dialog-header>
  </div> -->
</ng-template>

<ng-container *ngTemplateOutlet="bamDialog"></ng-container>
